import { isEmptyVal, safeJSONParse } from '@/utils';
import { includes } from 'lodash';
import { companySetupProductTypeMap } from '@/common/constants';
import { translateToEn } from '@/plugins/i18n';
import { UTM_CONTENT_CODE } from '@/views/succezz/utils/email-ctas-tracking';
import { navigateParentWindowTo } from '@/utils/modal-utils.js'

export default {
  props: {
    eligibleProductTypeJson: {
      type: String,
      default: '[]',
    },
  },
  methods: {
    goCompanySetup(targetURL = '/setup-guide') {
      this.$tracking.postPurchase('company setup');
      if (this.$context.is.modal) {
        navigateParentWindowTo(targetURL);
      } else {
        window.location.href = targetURL;
      }
    },
  },
  computed: {
    companySetupProductTypeList() {
      const eligibleProductType = safeJSONParse(this.eligibleProductTypeJson, []);
      return isEmptyVal(eligibleProductType) ?
        safeJSONParse(this.$config?.('eligibleProductTypeJson') || '[]', [])
        : eligibleProductType;
    },
    companySetupAccount() {
      // setup the numbers of product more than one, should show setup account
      return this.companySetupProductTypeList?.length > 1;
    },
    isJustSetupOneProduct() {
      return (this.companySetupProductTypeList || []).length === 1;
    },
    companySetupPro() {
      return this.isJustSetupOneProduct && includes(this.companySetupProductTypeList, companySetupProductTypeMap.pro);
    },
    companySetupProPlus() {
      return this.isJustSetupOneProduct && includes(this.companySetupProductTypeList, companySetupProductTypeMap.pro_plus);
    },
    companySetupBiz() {
      return this.isJustSetupOneProduct && includes(this.companySetupProductTypeList, companySetupProductTypeMap.biz);
    },
    companySetupBizPlus() {
      return this.isJustSetupOneProduct && includes(this.companySetupProductTypeList, companySetupProductTypeMap.biz_plus);
    },
    companySetupEduSchCmpPlus() {
      return this.isJustSetupOneProduct && includes(this.companySetupProductTypeList, companySetupProductTypeMap.edu_sch_cmp_plus);
    },
    setUpButtonUtmContentForTracking() {
      if (this.companySetupPro) {
        return UTM_CONTENT_CODE.setUpZoomWorkplacePro;
      } else if (this.companySetupProPlus) {
        return UTM_CONTENT_CODE.setUpZoomWorkplaceProPlus;
      } else if (this.companySetupBiz) {
        return UTM_CONTENT_CODE.setUpZoomWorkplaceBiz;
      } else if (this.companySetupBizPlus) {
        return UTM_CONTENT_CODE.setUpZoomWorkplaceBizPlus;
      } else if (this.companySetupEduSchCmpPlus) {
        return 'set-up-zoom-workplace-edu-sch-cmp-plus';
      } else if (this.companySetupAccount) {
        return UTM_CONTENT_CODE.setUpYourZoomAccount;
      }

      return '';
    },
    companySetupZoomOneName() {
      if (this.companySetupPro) {
        return this.$t('billing.success.setup_zoom_one_pro');
      } else if (this.companySetupProPlus) {
        return this.$t('billing.success.setup_zoom_one_pro_plus');
      } else if (this.companySetupBiz) {
        return this.$t('billing.success.setup_zoom_one_biz');
      } else if (this.companySetupBizPlus) {
        return this.$t('billing.success.setup_zoom_one_biz_plus');
      } else if (this.companySetupEduSchCmpPlus) {
        return this.$t('billing.success.setup_zoom_one_edu_sch_cmp_plus');
      } else if (this.companySetupAccount) {
        return this.$t('billing.success.setup_zoom_account');
      }

      return '';
    },
    companySetupZoomOneEnName() {
      if (this.companySetupPro) {
        return translateToEn('billing.success.setup_zoom_one_pro');
      } else if (this.companySetupProPlus) {
        return translateToEn('billing.success.setup_zoom_one_pro_plus');
      } else if (this.companySetupBiz) {
        return translateToEn('billing.success.setup_zoom_one_biz');
      } else if (this.companySetupBizPlus) {
        return translateToEn('billing.success.setup_zoom_one_biz_plus');
      } else if (this.companySetupEduSchCmpPlus) {
        return translateToEn('billing.success.setup_zoom_one_edu_sch_cmp_plus');
      } else if (this.companySetupAccount) {
        return translateToEn('billing.success.setup_zoom_account');
      }

      return '';
    },
    companySetupZoomOneDesc() {
      if (this.companySetupPro) {
        return this.$t('billing.zoom_one_pro.set_up_success_msg');
      } else if (this.companySetupBiz) {
        return this.$t('billing.zoom_one_biz.set_up_success_msg');
      } else if (this.companySetupBizPlus) {
        return this.$t('billing.zobizplus.set_up_new_biz_plus_success_msg');
      } else if (this.companySetupAccount) {
        return this.$t('billing.success.confirmation.set_up_desc');
      }

      return '';
    },
  },
};
